import { NotificationFilterId } from '../domains/notification-inbox';

export class LoadNotificationInboxAction {
  static readonly type = '[NotificationInbox] Load';
  constructor(
    public readonly filter: NotificationFilterId = 'all',
    public readonly search?: string,
    public readonly refresh = false,
  ) {}
}

export class LoadMoreNotificationsAction {
  static readonly type = '[NotificationInbox] Load More';
}

export class LoadUnreadNotificationCountAction {
  static readonly type = '[NotificationInbox] Load Unread Count';
}

export class RefreshNotificationMetricsAction {
  static readonly type = '[NotificationInbox] Refresh Metrics';
}

export class MarkNotificationReadAction {
  static readonly type = '[NotificationInbox] Mark Read';
  constructor(public readonly notificationId: string) {}
}

export class MarkNotificationUnreadAction {
  static readonly type = '[NotificationInbox] Mark Unread';
  constructor(public readonly notificationId: string) {}
}

export class MarkAllNotificationsReadAction {
  static readonly type = '[NotificationInbox] Mark All Read';
}

export class DeleteNotificationAction {
  static readonly type = '[NotificationInbox] Delete';
  constructor(public readonly notificationId: string) {}
}
